<template>
  <SnackBar ref="snackbar" />
  <v-container fluid>
    <div class="flex-title">
      <v-btn
        style="background: #f9f8f8; font-size: 18px"
        size="small"
        @click="this.$router.go(-1)"
        icon
      >
        <v-icon color="#004984">mdi-arrow-left</v-icon>
      </v-btn>
      <v-skeleton-loader
        class="skeleton-wrapper sprint-text"
        type="text"
        :loading="isLoading"
        v-if="isLoading"
      ></v-skeleton-loader>
      <h1 class="task-title" v-else>
        {{ task.titulo }}
      </h1>
    </div>

    <v-divider class="mx-4" inset vertical></v-divider>
    <v-row>
      <v-col cols="7">
        <v-card flat color="transparent">
          <v-card-title class="task-card-title">
            Detalhes da tarefa
          </v-card-title>
          <v-card-text>
            <v-row>
              <v-col cols="6">
                <v-row>
                  <v-col cols="12">
                    <v-subheader class="text-stroked">Prioridade: </v-subheader>
                    <v-skeleton-loader
                      class="infos"
                      type="text"
                      :loading="isLoading"
                      v-if="isLoading"
                    ></v-skeleton-loader>
                    <span class="span-info" v-else>{{ task.prioridade }}</span>
                  </v-col>
                  <v-col cols="12">
                    <v-subheader class="text-stroked"
                      >Data início:
                    </v-subheader>
                    <v-skeleton-loader
                      class="infos"
                      type="text"
                      :loading="isLoading"
                      v-if="isLoading"
                    ></v-skeleton-loader>
                    <span class="span-info" v-else>{{
                      formatarData(task.dt_inicio)
                    }}</span>
                  </v-col>
                  <v-col cols="12">
                    <v-subheader class="text-stroked">Data fim: </v-subheader>
                    <v-skeleton-loader
                      class="infos"
                      type="text"
                      :loading="isLoading"
                      v-if="isLoading"
                    ></v-skeleton-loader>
                    <span class="span-info" v-else>{{
                      formatarData(task.dt_fim)
                    }}</span>
                  </v-col>
                </v-row>
              </v-col>
              <v-col cols="6">
                <v-row>
                  <v-col cols="12">
                    <v-subheader class="text-stroked">Status: </v-subheader>
                    <v-skeleton-loader
                      class="infos"
                      type="text"
                      :loading="isLoading"
                      v-if="isLoading"
                    ></v-skeleton-loader>
                    <span class="span-info" v-else>{{
                      task.status_tarefa
                    }}</span>
                  </v-col>
                  <v-col cols="12">
                    <v-subheader class="text-stroked">Tipo: </v-subheader>
                    <v-skeleton-loader
                      class="infos"
                      type="text"
                      :loading="isLoading"
                      v-if="isLoading"
                    ></v-skeleton-loader>
                    <badge class="badge-config" v-else :color="badgeColor">{{
                      task.tipo_tarefa
                    }}</badge>
                  </v-col>
                  <v-col cols="12">
                    <v-subheader class="text-stroked"
                      >Story points:
                    </v-subheader>
                    <v-skeleton-loader
                      class="infos"
                      type="text"
                      :loading="isLoading"
                      v-if="isLoading"
                    ></v-skeleton-loader>
                    <span class="span-info circle" v-else>{{
                      task.storypoint
                    }}</span>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>

        <v-divider class="mx-4" inset vertical></v-divider>

        <v-card flat color="transparent" class="mb-10">
          <v-card-title class="task-card-title">
            Descrição da atividade
          </v-card-title>
          <v-card>
            <p class="text-area">
              {{ task.descricao }}
            </p>
          </v-card>
        </v-card>
      </v-col>

      <!-- TODO: Remover none para ajustar fluxo Assumir tarefa -->
      <v-col cols="5">
        <v-card flat color="transparent">
          <v-card-title class="task-card-title no-margin-padding">
            Pessoas
          </v-card-title>
          <v-card-text class="reponsavel-width">
            <v-subheader style="padding-top: 18px" class="text-stroked"
              >Responsável:
            </v-subheader>
            <v-select
              v-if="!isScrum"
              v-model="selectedItems"
              :items="
                users.map((user) => ({
                  title: user.usuario_git,
                  image: user.img_url,
                }))
              "
              clearable
              :multiple="task.tipo_tarefa == 'DOCUMENTACAO'"
              variant="underlined"
              hint="Clique em assumir tarefa após selecionar"
              persistent-hint="Clique em assumir tarefa após selecionar"
              return-object
            >
              <template #item="{ props, item }">
                <v-list-item
                  v-bind="props"
                  open-on-clear
                  :prepend-avatar="item?.raw?.image"
                  :title="item?.raw?.title"
                ></v-list-item>
              </template>
              <template #selection="{ item, index }">
                <v-chip v-if="index < 2">
                  <v-avatar size="24" style="margin-right: 5px">
                    <img
                      :src="item.raw.image"
                      alt="User Image"
                      class="icon-user"
                    />
                  </v-avatar>
                  <span>{{ item.title }}</span>
                </v-chip>
                <span
                  v-if="index === 2"
                  class="text-grey text-caption align-self-center"
                >
                  (+{{ selectedItems.length - 2 }} outros)
                </span>
              </template>
            </v-select>
            <div v-else style="padding-top: 18px">
              <div v-if="responsaveisAtuais.length > 0">
                <div
                  v-for="responsavel in responsaveisAtuais"
                  :key="responsavel.usuario_git"
                  style="margin-bottom: 5px"
                >
                  <v-chip>
                    <v-avatar size="24" style="margin-right: 8px">
                      <img
                        :src="responsavel.img_url"
                        alt="Imagem do Usuário"
                        class="icon-user"
                      />
                    </v-avatar>
                    <span>{{ responsavel.usuario_git }}</span>
                  </v-chip>
                </div>
              </div>
              <div v-else>
                <span>Não há responsáveis pela tarefa.</span>
              </div>
            </div>
            <!-- <span class="span-info">{{ task.responsavel }}</span> -->
          </v-card-text>
          <!-- <p>
            Valores selecionados: {{ selectedItems }}, tipo:
            {{ typeof selectedItems }}
          </p> -->
        </v-card>
      </v-col>
    </v-row>

    <template>
      <div>
        <v-dialog v-model="showConfirmationModalAssumir" width="520px">
          <v-card>
            <v-card-title>
              <span>Assumir tarefa</span>
            </v-card-title>
            <v-card-text>
              <p>Deseja que os seguintes usuários assumam a tarefa?</p>
              <br />
              <ul style="list-style: none">
                <li
                  v-if="
                    Array.isArray(selectedItems) && selectedItems.length > 0
                  "
                >
                  <p
                    v-for="user in selectedItems"
                    :key="user.title"
                    style="margin-bottom: 6px"
                  >
                    <v-avatar size="28" style="margin-right: 5px">
                      <img style="width: 100%" :src="user.image" alt="Avatar" />
                    </v-avatar>
                    <strong>{{ user.title }}</strong>
                  </p>
                </li>
                <li
                  v-else-if="
                    Array.isArray(selectedItems) && selectedItems.length === 0
                  "
                >
                  <strong>Nenhum usuário foi selecionado</strong>
                </li>
                <li
                  v-else-if="selectedItems && typeof selectedItems === 'object'"
                >
                  <strong>
                    <v-avatar size="28" style="margin-right: 5px">
                      <img
                        style="width: 100%"
                        :src="selectedItems.image"
                        alt="Avatar"
                      />
                    </v-avatar>
                    {{ selectedItems.title }}
                  </strong>
                </li>
                <li v-else>
                  <strong>Nenhum usuário foi selecionado</strong>
                </li>
              </ul>
            </v-card-text>
            <v-card-actions>
              <v-btn
                color="red"
                text
                @click="showConfirmationModalAssumir = false"
              >
                Cancelar
              </v-btn>
              <v-btn
                color="#004984"
                text
                @click="assumirTarefa"
                :disabled="
                  (Array.isArray(selectedItems) &&
                    selectedItems.length === 0) ||
                  (typeof selectedItems === 'object' && !selectedItems)
                "
              >
                Confirmar
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </div>
    </template>

    <template>
      <div>
        <v-dialog v-model="showConfirmationModal" width="400px">
          <v-card>
            <v-card-title>
              <span>Confirmar Exclusão</span>
            </v-card-title>
            <v-card-text>
              <p>Deseja realmente excluir esta tarefa?</p>
            </v-card-text>
            <v-card-actions>
              <v-btn color="blue" text @click="showConfirmationModal = false">
                Cancelar
              </v-btn>
              <v-btn
                color="red"
                text
                @click="excluirTarefa(this.$route.params.idTarefa)"
              >
                Confirmar
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </div>
    </template>

    <template>
      <div>
        <v-dialog v-model="showModalGrauDeParticipacao" width="520px">
          <v-card>
            <v-card-title>
              <span
                ><v-icon
                  style="margin-right: 5px"
                  color="black"
                  icon="mdi-account-group"
                ></v-icon>
                Grau de Participação</span
              >
            </v-card-title>
            <v-form v-model="valid">
              <v-card-text>
                <p>Informe o grau de participação dos membros abaixo:</p>
                <br />
                <v-col
                  v-for="responsavel in responsaveisAtuais"
                  :key="responsavel.id_usuario"
                  cols="12"
                >
                  <v-row>
                    <v-avatar size="24" style="margin-right: 5px">
                      <img
                        class="icon-user"
                        :src="responsavel.img_url"
                        alt="Avatar"
                      />
                    </v-avatar>
                    <span class="label">{{ responsavel.nome }}</span>
                    <br />
                  </v-row>
                  <v-row>
                    <v-text-field
                      v-model="responsavel.grau_participacao"
                      dense
                      required
                      type="number"
                      min="0"
                      max="100"
                      variant="underlined"
                      label="Grau de participação"
                      :rules="validacaoInput(responsavel)"
                    ></v-text-field>
                  </v-row>
                </v-col>
                <span style="font-size: 12px; color: #7a7a7a"
                  >*Distribuir no máximo 100 pontos entre os membros</span
                >
              </v-card-text>
            </v-form>

            <v-card-actions>
              <v-btn
                color="red"
                text
                @click="showModalGrauDeParticipacao = false"
              >
                Cancelar
              </v-btn>
              <v-btn
                :disabled="!valid"
                color="#004984"
                text
                @click="informarGrau()"
              >
                Confirmar
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </div>
    </template>

    <v-btn
      v-if="!isScrum"
      color="#004984"
      v-bind="props"
      class="button-config color-margin"
      @click="showConfirmationModalAssumir = true"
    >
      Assumir Tarefa
      <v-icon right style="margin-left: 5px">mdi-account-check</v-icon>
    </v-btn>

    <v-btn
      v-if="!isScrum"
      color="red"
      title="Excluir tarefa"
      v-bind="props"
      class="color-margin"
      @click="showConfirmationModal = true"
    >
      Excluir Tarefa
      <v-icon right style="margin-left: 5px">mdi-cancel</v-icon>
    </v-btn>

    <ModalAtualizarTarefa
      v-if="!isScrum"
      :id-tarefa="parseInt(this.$route.params.idTarefa)"
      :task="task"
      @tarefa-atualizada="atualizarTarefa"
    />

    <v-tooltip
      v-if="!isScrum"
      text="Disponível apenas ao finalizar a tarefa"
      location="bottom"
    >
      <template #activator="{ props }">
        <v-btn
          v-bind="props"
          style="margin-left: 20px; background: white"
          @click="
            showModalGrauDeParticipacao = true;
            responsaveisTarefa();
          "
          :disabled="task.status_tarefa !== 'FINALIZADO'"
          variant="outlined"
          color="#004984"
        >
          Grau de Participação
          <v-icon right style="margin-left: 5px">mdi-account-group</v-icon>
        </v-btn>
      </template>
    </v-tooltip>
  </v-container>
</template>

<script>
import axios from 'axios';
import { VSkeletonLoader } from 'vuetify/labs/VSkeletonLoader';

import Badge from '@/components/BadgeInfo.vue';
import ModalAtualizarTarefa from '@/components/dialogs/ModalAtualizarTarefa.vue';
import SnackBar from '@/components/SnackBar.vue';
import store from '@/store/store';

const API_URL = process.env.VUE_APP_API_URL || 'http://localhost:3000';

export default {
  components: {
    SnackBar,
    Badge,
    ModalAtualizarTarefa,
    VSkeletonLoader,
  },
  data: () => ({
    task: {},
    idBacklogSprint: '',
    titulomilestone: '',
    isLoading: true,
    showConfirmationModal: false,
    showConfirmationModalAssumir: false,
    showModalGrauDeParticipacao: false,
    selectedItems: [],
    responsaveis: [],
    responsaveisAtuais: [],
    users: [],
    valid: false,
  }),
  created() {
    this.fetchTarefa(this.$route.params.idTarefa);
    this.fetchSprint();

    // setTimeout(() => {
    //   this.obterMembrosEquipe(this.task.id_projeto);
    // }, 500);
  },
  computed: {
    badgeColor() {
      const mappings = {
        TECNICA: '#800080', // Purple
        DOCUMENTACAO: '#0000ff', // Azul
        IMPLEMENTACAO: '#008080', // Teal
        TESTE_INDEPENDENTE: '#ffa500', // Laranja
        TESTE_EQUIPE: '#008000', // Verde
        CORRECAO_BUG: '#ff0000', // Vermelho
        default: '#ffffff',
      };

      return mappings[this.task.tipo_tarefa] || mappings.default;
    },
    isDev() {
      return localStorage.getItem('funcao') === 'Desenvolvedor';
    },
    isCoord() {
      return localStorage.getItem('funcao') === 'Coordenador';
    },
    isScrum() {
      return localStorage.getItem('funcao') === 'Scrum Master';
    },
  },
  methods: {
    formatarData(data) {
      if (data == null) {
        return 'Não definida';
      }
      const dataObj = new Date(data);
      const dia = dataObj.getDate().toString().padStart(2, '0');
      const mes = (dataObj.getMonth() + 1).toString().padStart(2, '0');
      const ano = dataObj.getFullYear();

      return `${dia}/${mes}/${ano}`;
    },

    validacaoInput(responsavel) {
      /* eslint-disable */

      const grau =
        responsavel.grau_participacao.length === 0
          ? NaN
          : Number(responsavel.grau_participacao);

      // console.log(
      //   responsavel.grau_participacao,
      //   typeof responsavel.grau_participacao,
      //   grau
      // );

      if (Number.isNaN(grau)) {
        return ['Valor não permitido, insira um valor entre 0 e 100.'];
      } else if (grau < 0) {
        return ['Valor não permitido, insira um valor maior ou igual a 0.'];
      } else if (grau > 100) {
        return ['Valor não permitido, insira um valor menor ou igual a 100.'];
      }
      /* eslint-enable */
    },

    fetchTarefa(idTarefa) {
      axios
        .get(API_URL + `/tarefas/visualizar/${idTarefa}`, {
          headers: {
            Authorization: `Bearer ${store.state.token}`,
          },
        })
        .then((response) => {
          this.isLoading = false;
          this.task = response.data;
          console.log(this.task);
          console.log(this.task.tb_itembacklogsprint[0].id_item_backlog_sprint);
          this.idBacklogSprint =
            this.task.tb_itembacklogsprint[0].id_item_backlog_sprint;
          this.task.tb_itembacklogsprint[0].tb_responsavel.forEach(
            (responsavel) => {
              this.selectedItems.push({
                title: responsavel.tb_usuario.usuario_git,
                image: responsavel.tb_usuario.img_url,
              });
              console.log(responsavel);
            },
          );
          this.obterMembrosEquipe(this.task.id_projeto);
          this.responsaveisTarefa();
        })
        .catch((error) => {
          console.error(error);
        });
    },

    assumirTarefa() {
      /* eslint-disable */
      const responsaveisArray = Array.isArray(this.selectedItems)
        ? this.selectedItems.map((item) => ({
            usuario_git: item.title,
          }))
        : [{ usuario_git: this.selectedItems.title }];
      axios
        .post(
          API_URL + `/tarefas/assumir/${this.idBacklogSprint}`,
          {
            responsaveis: responsaveisArray,
          },
          {
            headers: {
              Authorization: `Bearer ${store.state.token}`,
            },
          }
        )
        .then((response) => {
          this.$refs.snackbar.showSuccessSnackbar(
            'Concluído!',
            `${response.data}`
          );
          this.showConfirmationModalAssumir = false;
        })
        .catch((error) => {
          console.error(error);
          this.$refs.snackbar.showErrorSnackbar(
            'Hm... Algo deu errado',
            'Por algum motivo, não foi possível assumir essa tarefa.'
          );
          this.showConfirmationModalAssumir = false;
        });
      /* eslint-enable */
    },

    // TODO: Adicionar confimação de exclusão (force=true)
    excluirTarefa(idTarefa) {
      console.log(idTarefa);
      axios
        /*eslint-disable*/
        .delete(API_URL + `/tarefas/${idTarefa}`, {
          headers: {
            Authorization: `Bearer ${store.state.token}`,
          },
        })
        .then((response) => {
          console.log(response.data);
          console.log(this.task.tb_itembacklogsprint.id_item_backlog_sprint);
          this.$refs.snackbar.showSuccessSnackbar(
            'Concluído!',
            'Tarefa excluída com sucesso'
          );
          setTimeout(() => {
            this.$router.push({
              name: 'sprints/backlog',
              params: { id: parseInt(this.$route.params.id) },
            });
          }, 2000);
        })
        .catch((error) => {
          console.error(error);
          this.$refs.snackbar.showErrorSnackbar(
            'Hm... Algo deu errado',
            'Por algum motivo, não foi possível assumir essa tarefa.'
          );
          this.showConfirmationModal = false;
        });
      /* eslint-enable */
    },

    fetchSprint() {
      axios
        .get(API_URL + `/sprints/${this.$route.params.id}`, {
          headers: {
            Authorization: `Bearer ${store.state.token}`,
          },
        })
        .then((response) => {
          this.titulomilestone = response.data.titulomilestone;
          console.log(response.data.titulomilestone);
        })
        .catch((error) => {
          console.error(error);
        });
    },

    atualizarTarefa(tarefaAtualizada) {
      this.task = tarefaAtualizada;
    },

    obterMembrosEquipe(idProjeto) {
      axios
        .get(`${API_URL}/equipes/projeto/${idProjeto}`, {
          headers: {
            Authorization: `Bearer ${store.state.token}`,
          },
        })
        .then((response) => {
          const membrosEquipe = response.data.tb_equipe.tb_membro;
          this.users = membrosEquipe.map((membro) => membro.tb_usuario);
          console.log(this.users);
        })
        .catch((error) => {
          console.error(error);
        });
    },

    informarGrau() {
      /* eslint-disable */
      const responsaveis = this.responsaveisAtuais.map((responsavel) => ({
        usuario_git: responsavel.usuario_git,
        grau_participacao: parseInt(responsavel.grau_participacao),
      }));
      console.log(responsaveis);
      axios
        .patch(
          API_URL + `/tarefas/participacao/${this.idBacklogSprint}`,
          {
            responsaveis: responsaveis,
          },
          {
            headers: {
              Authorization: `Bearer ${store.state.token}`,
            },
          }
        )
        .then((response) => {
          this.$refs.snackbar.showSuccessSnackbar(
            'Concluído!',
            `${response.data}`
          );
          this.showModalGrauDeParticipacao = false;
        })
        .catch((error) => {
          console.error(error);
          this.$refs.snackbar.showErrorSnackbar(
            'Hm... Algo deu errado',
            'Por algum motivo, não foi possível informar o grau de participação dessa tarefa.'
          );
          this.showModalGrauDeParticipacao = false;
        });
      /* eslint-enable */
    },

    responsaveisTarefa() {
      /*eslint-disable*/
      axios
        .get(`${API_URL}/tarefas/responsaveis/${this.idBacklogSprint}`, {
          headers: {
            Authorization: `Bearer ${store.state.token}`,
          },
        })
        .then((response) => {
          this.responsaveisAtuais = response.data.map((item) => ({
            nome: item.tb_usuario.nome,
            usuario_git: item.tb_usuario.usuario_git,
            img_url: item.tb_usuario.img_url,
            grau_participacao: item.grau_participacao,
          }));

          console.log(this.responsaveisAtuais);
        })
        .catch((error) => {
          console.error(error);
        });
      /* eslint-enable */
    },
  },
};
</script>

<style scoped>
.task-title {
  font-size: 22px;
  font-weight: bold;
}
.task-card-title {
  font-size: 18px;
  font-weight: bold;
  padding-left: 0;
  margin-bottom: 10px;
}
.text-stroked {
  -webkit-text-stroke: 0.5px black;
}
.text-area {
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
  padding: 18px;
  height: 120px;
  text-align: justify;
}
.button-config {
  background-color: #004984;
  color: white;
}
.badge-config {
  display: inline-flex;
}
.circle {
  width: 23px;
  height: 23px;
  border-radius: 50%;
  background-color: #ccc;
  display: inline-flex;
  justify-content: center;
  align-items: center;
  font-size: 16px;
  font-weight: bold;
}
.span-info {
  text-shadow: 2px 1px 10px gray;
}
.color-margin {
  color: white;
  margin-right: 20px;
}
.skeleton-wrapper {
  width: 50%;
  background: transparent;
}
.sprint-text {
  font-size: 22px;
  font-weight: bold;
}
.infos {
  background: none;
  width: 50%;
  height: 0;
  display: inline-flex;
}
.reponsavel-width {
  display: flex;
  align-items: flex-start;
  gap: 10px;
}
.no-margin-padding {
  margin-bottom: 0;
  padding-bottom: 0;
}
.icon-user {
  width: 100%;
}
.flex-title {
  display: flex;
  align-items: center;
  gap: 10px;
}
</style>
